var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedThroat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 259,
    viewBox: "0 0 172 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.128 51.1252V60.3129H100.3V130.752L70.7151 181.048L70.9219 182.816H34.0253L34.1096 182.235L3.82823 130.752V60.3129H0V51.1252H9.18776V48.0626H16.0786V45H54.3609L53.0057 54.1878H1.53129V57.2503H101.831V54.1878H55.4635L55.0194 50.4897V50.482L55.8922 45H88.0494V48.0626H94.9402V51.1252H104.128Z",
    fill: "#8476EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4176 181.051H43.0144V246.368H60.4176V181.051Z",
    fill: "#8476EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3103 100.045V133.557L45.4342 181.372H58.8713L89.076 132.577V100.045H19.3103Z",
    fill: "#8476EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7205 108.004V137.405L47.3463 182.391L48.2757 258.071H56.4559L57.2009 182.391L84.9722 134.573L84.9427 108.004H23.7205Z",
    fill: "#8476EF",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 119.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 127.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 135.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 143.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 146.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 132.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 142.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 124.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 137.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 151.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 151.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 160.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 168.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 159.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 167.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 166.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 159.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 152.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 146.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 138.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 130.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 136.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 145.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 153.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 175.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 183.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 191.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 199.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 207.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 215.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 223.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 231.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 242.5,
    r: 3.5,
    fill: "#ED2024"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0188 50.482V50.4897L54.4369 54.1878H53.0051L54.3603 45L55.0188 50.482Z",
    fill: "#8476EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4377 54.1895L53.9476 57.252H1.53149V54.1895H54.4377Z",
    fill: "#8476EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8929 45L55.02 50.482L54.3616 45H55.8929Z",
    fill: "#8476EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8317 57.2504H52.5547L53.0064 54.1878L54.3616 45L55.0201 50.482V50.4897L55.4642 54.1878L55.8317 57.2504Z",
    fill: "#8476EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.831 54.1895V57.252H55.8314L55.4639 54.1895H101.831Z",
    fill: "#8476EF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.831 54.1895H1.53149V57.252H101.831V54.1895Z",
    fill: "#8476EF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    width: 85,
    height: 30,
    rx: 15,
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99 10.624V11.98H95.508V14.128H98.184V15.46H95.508V19H93.828V10.624H99ZM106.371 15.532C106.371 15.772 106.355 15.988 106.323 16.18H101.463C101.503 16.66 101.671 17.036 101.967 17.308C102.263 17.58 102.627 17.716 103.059 17.716C103.683 17.716 104.127 17.448 104.391 16.912H106.203C106.011 17.552 105.643 18.08 105.099 18.496C104.555 18.904 103.887 19.108 103.095 19.108C102.455 19.108 101.879 18.968 101.367 18.688C100.863 18.4 100.467 17.996 100.179 17.476C99.8993 16.956 99.7593 16.356 99.7593 15.676C99.7593 14.988 99.8993 14.384 100.179 13.864C100.459 13.344 100.851 12.944 101.355 12.664C101.859 12.384 102.439 12.244 103.095 12.244C103.727 12.244 104.291 12.38 104.787 12.652C105.291 12.924 105.679 13.312 105.951 13.816C106.231 14.312 106.371 14.884 106.371 15.532ZM104.631 15.052C104.623 14.62 104.467 14.276 104.163 14.02C103.859 13.756 103.487 13.624 103.047 13.624C102.631 13.624 102.279 13.752 101.991 14.008C101.711 14.256 101.539 14.604 101.475 15.052H104.631ZM113.778 15.532C113.778 15.772 113.762 15.988 113.73 16.18H108.87C108.91 16.66 109.078 17.036 109.374 17.308C109.67 17.58 110.034 17.716 110.466 17.716C111.09 17.716 111.534 17.448 111.798 16.912H113.61C113.418 17.552 113.05 18.08 112.506 18.496C111.962 18.904 111.294 19.108 110.502 19.108C109.862 19.108 109.286 18.968 108.774 18.688C108.27 18.4 107.874 17.996 107.586 17.476C107.306 16.956 107.166 16.356 107.166 15.676C107.166 14.988 107.306 14.384 107.586 13.864C107.866 13.344 108.258 12.944 108.762 12.664C109.266 12.384 109.846 12.244 110.502 12.244C111.134 12.244 111.698 12.38 112.194 12.652C112.698 12.924 113.086 13.312 113.358 13.816C113.638 14.312 113.778 14.884 113.778 15.532ZM112.038 15.052C112.03 14.62 111.874 14.276 111.57 14.02C111.266 13.756 110.894 13.624 110.454 13.624C110.038 13.624 109.686 13.752 109.398 14.008C109.118 14.256 108.946 14.604 108.882 15.052H112.038ZM114.572 15.652C114.572 14.98 114.704 14.384 114.968 13.864C115.24 13.344 115.608 12.944 116.072 12.664C116.536 12.384 117.052 12.244 117.62 12.244C118.052 12.244 118.464 12.34 118.856 12.532C119.248 12.716 119.56 12.964 119.792 13.276V10.12H121.496V19H119.792V18.016C119.584 18.344 119.292 18.608 118.916 18.808C118.54 19.008 118.104 19.108 117.608 19.108C117.048 19.108 116.536 18.964 116.072 18.676C115.608 18.388 115.24 17.984 114.968 17.464C114.704 16.936 114.572 16.332 114.572 15.652ZM119.804 15.676C119.804 15.268 119.724 14.92 119.564 14.632C119.404 14.336 119.188 14.112 118.916 13.96C118.644 13.8 118.352 13.72 118.04 13.72C117.728 13.72 117.44 13.796 117.176 13.948C116.912 14.1 116.696 14.324 116.528 14.62C116.368 14.908 116.288 15.252 116.288 15.652C116.288 16.052 116.368 16.404 116.528 16.708C116.696 17.004 116.912 17.232 117.176 17.392C117.448 17.552 117.736 17.632 118.04 17.632C118.352 17.632 118.644 17.556 118.916 17.404C119.188 17.244 119.404 17.02 119.564 16.732C119.724 16.436 119.804 16.084 119.804 15.676ZM131.696 10.624V11.98H129.464V19H127.784V11.98H125.552V10.624H131.696ZM136.666 12.256C137.17 12.256 137.618 12.368 138.01 12.592C138.402 12.808 138.706 13.132 138.922 13.564C139.146 13.988 139.258 14.5 139.258 15.1V19H137.578V15.328C137.578 14.8 137.446 14.396 137.182 14.116C136.918 13.828 136.558 13.684 136.102 13.684C135.638 13.684 135.27 13.828 134.998 14.116C134.734 14.396 134.602 14.8 134.602 15.328V19H132.922V10.12H134.602V13.18C134.818 12.892 135.106 12.668 135.466 12.508C135.826 12.34 136.226 12.256 136.666 12.256ZM142.535 13.384C142.751 13.032 143.031 12.756 143.375 12.556C143.727 12.356 144.127 12.256 144.575 12.256V14.02H144.131C143.603 14.02 143.203 14.144 142.931 14.392C142.667 14.64 142.535 15.072 142.535 15.688V19H140.855V12.352H142.535V13.384ZM148.659 19.108C148.019 19.108 147.443 18.968 146.931 18.688C146.419 18.4 146.015 17.996 145.719 17.476C145.431 16.956 145.287 16.356 145.287 15.676C145.287 14.996 145.435 14.396 145.731 13.876C146.035 13.356 146.447 12.956 146.967 12.676C147.487 12.388 148.067 12.244 148.707 12.244C149.347 12.244 149.927 12.388 150.447 12.676C150.967 12.956 151.375 13.356 151.671 13.876C151.975 14.396 152.127 14.996 152.127 15.676C152.127 16.356 151.971 16.956 151.659 17.476C151.355 17.996 150.939 18.4 150.411 18.688C149.891 18.968 149.307 19.108 148.659 19.108ZM148.659 17.644C148.963 17.644 149.247 17.572 149.511 17.428C149.783 17.276 149.999 17.052 150.159 16.756C150.319 16.46 150.399 16.1 150.399 15.676C150.399 15.044 150.231 14.56 149.895 14.224C149.567 13.88 149.163 13.708 148.683 13.708C148.203 13.708 147.799 13.88 147.471 14.224C147.151 14.56 146.991 15.044 146.991 15.676C146.991 16.308 147.147 16.796 147.459 17.14C147.779 17.476 148.179 17.644 148.659 17.644ZM152.927 15.652C152.927 14.98 153.059 14.384 153.323 13.864C153.595 13.344 153.959 12.944 154.415 12.664C154.879 12.384 155.395 12.244 155.963 12.244C156.459 12.244 156.891 12.344 157.259 12.544C157.635 12.744 157.935 12.996 158.159 13.3V12.352H159.851V19H158.159V18.028C157.943 18.34 157.643 18.6 157.259 18.808C156.883 19.008 156.447 19.108 155.951 19.108C155.391 19.108 154.879 18.964 154.415 18.676C153.959 18.388 153.595 17.984 153.323 17.464C153.059 16.936 152.927 16.332 152.927 15.652ZM158.159 15.676C158.159 15.268 158.079 14.92 157.919 14.632C157.759 14.336 157.543 14.112 157.271 13.96C156.999 13.8 156.707 13.72 156.395 13.72C156.083 13.72 155.795 13.796 155.531 13.948C155.267 14.1 155.051 14.324 154.883 14.62C154.723 14.908 154.643 15.252 154.643 15.652C154.643 16.052 154.723 16.404 154.883 16.708C155.051 17.004 155.267 17.232 155.531 17.392C155.803 17.552 156.091 17.632 156.395 17.632C156.707 17.632 156.999 17.556 157.271 17.404C157.543 17.244 157.759 17.02 157.919 16.732C158.079 16.436 158.159 16.084 158.159 15.676ZM163.448 13.732V16.948C163.448 17.172 163.5 17.336 163.604 17.44C163.716 17.536 163.9 17.584 164.156 17.584H164.936V19H163.88C162.464 19 161.756 18.312 161.756 16.936V13.732H160.964V12.352H161.756V10.708H163.448V12.352H164.936V13.732H163.448Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.5 33L141.469 27.75L147.531 27.75L144.5 33Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedThroat);
export default __webpack_public_path__ + "static/media/FeedThroat.8ee280548c0a327215413cf13826fd9b.svg";
export { ForwardRef as ReactComponent };